import { z } from 'zod'

export const paymentMethods = [
  'cash',
  'credit-card',
  'floa',
  'vacation-cheque',
  'bank-transfer',
  'vacation-e-cheque',
] as const

export type PaymentMethodFormValue = (typeof paymentMethods)[number]

export const checkoutFormSchema = z
  .object({
    buyerEmail: z.string().min(1, "L'adresse email est requise").email('Email invalide'),
    buyerPhone: z.string().optional(),
    createAccount: z.boolean(),
    depositAmount: z.number().optional(),
    isPayingInMultipleTimes: z.boolean(),
    password: z.string().optional(),
    passwordConfirmation: z.string().optional(),
    paymentMethod: z.enum(paymentMethods),
    promoCode: z.string().optional(),
    subscribeToNotifications: z.boolean(),
  })
  .superRefine((data, ctx) => {
    if (!data.createAccount) return

    if (!data.password || data.password.length < 8) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Le mot de passe doit contenir au moins 8 caractères',
        path: ['password'],
      })
    }

    if (!data.passwordConfirmation) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Veuillez confirmer votre mot de passe',
        path: ['passwordConfirmation'],
      })
    }

    if (data.password && data.passwordConfirmation && data.password !== data.passwordConfirmation) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Les mots de passe ne correspondent pas',
        path: ['passwordConfirmation'],
      })
    }
  })

export type CheckoutFormValues = z.infer<typeof checkoutFormSchema>
